import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthenticationService } from '../../services/authentication.service';
import { ContentService } from '../../services/content.service';
import { FeaturesService } from '../../services/features.service';
import { AccordionData } from '../../models/common';
import { Feature } from '../../enums/features';
import { BrandInfoService } from '../../services/brand-info.service';
import { BrandService } from '../../services/brand.service';
import { ComplaintsContact } from '../../models/complaints';

@Component({
  selector: 'complaints',
  templateUrl: './complaints.component.html',
})
export class ComplaintsComponent {
  public contentHTML: string = '';
  public contact: ComplaintsContact = null;
  public phoneNumber: string = '';
  public panels: string[] = null;
  public accordionData: AccordionData[] = null;
  public loadingContent: boolean = true;
  public complaintFormEnabled: boolean = false;
  public contentIntro: string = '';
  public introFormInstructions: string = '';
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private authenticationService: AuthenticationService,
    private contentService: ContentService,
    private featuresService: FeaturesService,
    private brandService: BrandService,
    private brandInfoService: BrandInfoService
  ) {}

  ngOnInit() {
    this.checkComplaintForm();
    this.loadContent();
    this.loadBrandInfo();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private checkComplaintForm(): void {
    this.authenticationService.isLoggedIn$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((loggedIn) => {
        if (loggedIn) {
          this.featuresService
            .hasFeature(Feature.ComplaintFormEnabled)
            .then((response) => (this.complaintFormEnabled = response));
        }
      });
  }

  private loadBrandInfo(): void {
    this.brandInfoService
      .loadInfo(this.brandService.getBrand())
      .then((brandInfo) => {
        if (brandInfo.phoneNumbers.complaints.number) {
          this.phoneNumber = brandInfo.phoneNumbers.complaints.number;
        }
      });
  }

  private loadContent(): void {
    this.contentService
      .getContent()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (result: any) => {
          if (result && result.complaints) {
            if (result.complaints.intro)
              this.contentIntro = result.complaints.intro;

            if (result.complaints.introFormInstructions)
              this.introFormInstructions =
                result.complaints.introFormInstructions;

            if (result.complaints.contact)
              this.contact = result.complaints.contact;

            if (result.complaints.accordions)
              this.accordionData = result.complaints.accordions;

            this.loadingContent = false;
          }
        },
        (err) => {
          this.loadingContent = false;
        }
      );
  }
}
